const LPSignUpPage = '/admin/seu-clube/cadastro-landing-page';

export default {
  LPSignUpPage,
};
